module.exports = __webpack_public_path__ + "img/mapyamahaaddlogo.3eede79c.png";